import React, { useState } from 'react';
import Scroll from './Scroll';
import SearchList from './Searchlist';

function Search({ details, tipologia }) {

  const [filterField, setFilterField] = useState(tipologia);
  const [searchField, setSearchField] = useState("");
  const [searchShow, setSearchShow] = useState(true);

  const filteredSevices = details.filter(
    service => {
      return (
        (
          service
            .name
            .toLowerCase()
            .includes(searchField.toLowerCase()) ||
          service
            .tag
            .includes(searchField.toLowerCase())
        )
        &&
        service
          .tipologia
          .toLowerCase()
          .includes(filterField.toLowerCase())
      );
    }
  );

  const handleChange = e => {
    setSearchField(e.target.value);
    if (e.target.value === "") {
      setSearchShow(true);
    }
    else {
      setSearchShow(true);
    }
  };

  const handleChange_op = e => {
    setFilterField(e.target.value);
  };

  function searchList() {
    if (searchShow) {
      return (
        <Scroll>
          <SearchList filteredSevices={filteredSevices} />
        </Scroll>
      );
    }
  }

  return (
    <section style={{width: '-webkit-fill-available', contain: 'content', textAlign: '-webkit-center'}}>
      <div>
        <h3 className='subTitleCustum'>Cerca altri servizi in: {tipologia}</h3>
      </div>
      <div className='barraLista'>
        <input
          className="searchBarra"
          type="search"
          placeholder="Cerca"
          onChange={handleChange}
        />
        {/* <div className='tipoBarra'>
        <select onChange={handleChange_op}>
          <option value={tipologia} selected>{tipologia}</option>
          <option value="">Comprendi tutti gli argomenti nella ricerca</option> 
          <option value="" selected disabled hidden>Filtra per argomento</option>
          <option disabled value="Donazioni - Trust - Tutela del Patrimonio">Donazioni - Trust - Tutela del Patrimonio</option>
          <option disabled value="Famiglia Unioni Civili e Successioni">Famiglia Unioni Civili e Successioni</option>
          <option disabled value="Compravendita e Finanziamenti">Compravendita e Finanziamenti</option>
          <option disabled value="Aziende e società">Aziende e società</option>
        </select>
        </div> */}
      </div>
      {searchList()}
    </section>
  );
}

export default Search;